import InnerPage from 'components/InnerPage/InnerPage'
import React, { useEffect, useState } from 'react'
import { pageViewEvent } from 'services/conversionevents'
import ProductService from 'services/ProductService'
import useInnerPage from 'store/InnerPageProvider'

const BlockPage = props => {
  const block_id = props.match.params.block_id
  const [block, setBlock] = useState('')
  const { init } = useInnerPage()

  useEffect(() => {
    init({
      resolver: () =>
        ProductService.getByBlock(block_id).then(data => {
          setBlock(data.block)
          document.title = data.block
          pageViewEvent()
          return data
        }),
    })
    // eslint-disable-next-line
  }, [block_id])

  return (
    <InnerPage
      backLink="/"
      backText="მთავარი"
      showPriceFilter={true}
      slug={block}
      breadcrumb={[
        { name: 'მთავარი', to: '/', active: false },
        { name: `${block}`, to: '#', active: true },
      ]}
    />
  )
}

export default BlockPage
